import React, { Component } from 'react';
import PropTypes from 'prop-types';
import compile from 'string-template/compile';
import iconHash from './src/iconHash';
class Icons extends Component {
	render() {
		const { name, width, height } = this.props;
		const icon = iconHash[name]?.svg ?? iconHash['defaultEvent'].svg;
		const compiler = compile(icon.svg);
		const svg = compiler({});
		return (
			<img
				src={'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg)}
				alt=""
				width={width}
				height={height}
			/>
		);
	}
}
Icons.defaultProps = {
	width: '30px',
	height: '30px',
	name: 'defaultEvent',
};

Icons.propTypes = {
	name: PropTypes.string,
	width: PropTypes.string,
	height: PropTypes.string,
};

export default Icons;
